<style lang="less">
    .page_con.class{
        width:100vw;
        height:100vh;
        overflow: hidden;
        background:url("../assets/images/bg2.png") no-repeat;
        background-size: 100% 100%;
        .top_con{
            width:100%;
            height:11vh;
            padding:0 5vw;
            display: flex;
            flex-direction: row-reverse;
            align-items: center;
            justify-content: space-between;
            background:url("../assets/images/topbar-file.png") no-repeat;
            background-size: 100% 100%;
            img{
                width:.5rem;
                height:auto;
                display: block;
            }
        }
        .content_con{
            width:92%;
            height:89vh;
                margin:0 auto;
            // padding:3vh 2vw;
            // border:.01rem solid #ddd;
            overflow-x: hidden;
            overflow-Y: auto;
            .date_con{
                width:100%;
                height:9vh;
                background:#fff;
                margin:0 auto 1vh;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .data_con{
                width:100%;
                height:auto;
                min-height: 79vh;
                background: #fff;
                padding:1vh 2vw;
                .filter_con{
                    width:100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding:3vh 0;
                    flex-wrap: wrap;
                    .filter{
                        width:22vw;
                        height:4vh;
                        line-height:4vh;
                        text-align: center;
                        border:.02rem solid #693905;
                        border-radius: 5px;
                        margin:0 2vw 1vh;
                        color:#693905;
                    }
                    .filter.active{
                        background:#E7E3BD;
                    }
                }
                .detail_con{
                    width:100%;
                    height:auto;
                    min-height: 60vh;
                    background:  #E7E3BD;
                    border-radius: .2rem;
                    padding:.15rem;
                    .detail{
                        width:100%;
                        height:auto;
                        min-height:58vh;
                        border-radius: .2rem;
                        background:#DFF2FC;
                    }
                }
            }
        }
    }
</style>
<template>
    <div class="page_con class">
        <div class="top_con">
            <img src="../assets/images/closer.png" alt="" @click="$router.go(-1)">
        </div>
        <div class="content_con">
            <div class="date_con">
                <selection :list="opts" width="40vw" height="5vh;" @change="selectDate"></selection>
            </div>
            <div class="data_con">
                <div class="filter_con">
                    <div :class="['filter',filter_active===index?'active':'']" v-for="(item,index) in filters" :key="index" @click="filterType(item,index)">{{item.name}}</div>
                </div>
                <div class="detail_con">
                    <div class="detail"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import selection from './selectdown'
export default {
    components:{
        selection
    },
    data(){
        return {
            filter_active:'',
            list:[],
            opts:[
                {
                    name:'10月 第一周'
                },
                {
                    name:'10月 第二周'
                },
                {
                    name:'10月 第三周'
                },
                {
                    name:'10月 第四周'
                },
            ],
            filters:[
                {
                    name:'粵語讀音'
                },
                {
                    name:'字詞訂正'
                },
                {
                    name:'組詞接龍'
                },
                {
                    name:'一詞多義'
                },
                {
                    name:'詞語搭配'
                },
                {
                    name:'句子訂正'
                },
            ],
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        filterType(item,index){
            console.log(11);
            this.filter_active = index;
        },
        selectDate(val){
            console.log(val);
        },
        getData(){
            let vm = this;
            this.$http.get('/GameDaily/LearnKits?rest_key=1').then(res=>{
                console.log(res);
                if(res.data.code == 1){
                    
                }
            })
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/info.vue